/**
 * SF-5172: the room the environment bar takes at the top of the window, for anything that must
 * sit below it. The bar shows on stage and on a developer's machine only: production is the
 * normal back office most people use, so it has no bar and no room is kept for one.
 */
import { APP_ENVIRONMENT, isProduction } from '../../config/env';

/** The bar's height where it shows; the default of --sf-environment-bar-height in EnvironmentBar.css. */
export const ENVIRONMENT_BAR_HEIGHT = 32;

/** Whether this back office shows the bar (not on production). */
export const showsEnvironmentBar = (env: string = APP_ENVIRONMENT) => !isProduction(env);

/** The room the bar takes here: its height, or none on production. */
export const environmentBarHeight = (env: string = APP_ENVIRONMENT) =>
  showsEnvironmentBar(env) ? ENVIRONMENT_BAR_HEIGHT : 0;

/** antd toasts below the bar, with antd's usual gap: 8px for messages, 24px for notifications. */
export const messageTop = (env: string = APP_ENVIRONMENT) => environmentBarHeight(env) + 8;
export const notificationTop = (env: string = APP_ENVIRONMENT) => environmentBarHeight(env) + 24;

/** Sets --sf-environment-bar-height to the room the bar takes here (none on production). */
export function applyEnvironmentBarSpace(env: string = APP_ENVIRONMENT) {
  document.documentElement.style.setProperty(
    '--sf-environment-bar-height',
    `${environmentBarHeight(env)}px`,
  );
}

/** For a `top` of something sticky: below the bar, not under it. */
export const BELOW_ENVIRONMENT_BAR = 'var(--sf-environment-bar-height)';

/** For a full-height page: the window less the bar, so a page that fits does not scroll. */
export const HEIGHT_BELOW_ENVIRONMENT_BAR = 'calc(100vh - var(--sf-environment-bar-height))';
